<template>
  <generic-modal :title="$t('template')" ref="generic_modal">
    <form>
      <div class="field">
        <label class="label">{{ $t("template") }}</label>
        <div class="control">
          <textarea
            class="textarea"
            rows="2"
            v-model="meta.template"
            :placeholder="$t('your template here')"
          ></textarea>
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("arguments") }}</label>
        <div
          class="field has-addons"
          v-for="(arg, aidx) in meta.arguments"
          :key="aidx"
        >
          <div class="control">
            <div class="button is-info">{{ arg.name }}</div>
          </div>
          <div class="control">
            <input
              class="input"
              type="text"
              :placeholder="$t('default value')"
              v-model="meta.arguments[aidx].default_value"
            />
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import { cloneDeep } from "lodash";

export default {
  name: "TemplateModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
      emitter_uuid: undefined,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return false;
      // return !v.meta.template;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(emitter_uuid) {
      let v = this;
      v.set_initial_state();
      if (emitter_uuid) {
        v.emitter_uuid = emitter_uuid;
        get("/fel/emitter/template", { uuid: emitter_uuid })
          .then((response) => {
            if (response) v.meta.template = response.template;
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = { uuid: v.emitter_uuid, ...v.meta };
      post("/fel/emitter/template", data)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.emitter_uuid = undefined;
      v.meta = {
        template: "",
        arguments: [],
        // barcode: "",
        // sale_price: "",
        // settings: {},
      };
      v.error = "";
    },
    calculate_variables() {
      let v = this;
      let argums = [];

      if (v.meta.template) {
        let regex = /\$\{[a-zA-Z_][a-zA-Z_0-9]*\}/gi;
        let __args = v.meta.template.match(regex);
        if (__args) {
          argums = argums.concat(
            __args.map((v) => {
              return { name: v, default_value: "" };
            })
          );
        }
      }

      let args_ = [];
      for (let index = 0; index < argums.length; index++) {
        const __arg = argums[index];
        let trgt = args_.find((_arg) => {
          return _arg.name == __arg.name;
        });
        if (!trgt) {
          args_.push(__arg);
        }
      }

      if (!v.meta.arguments) {
        v.meta.arguments = [];
      }

      let filtered = v.meta.arguments.filter((arg) => {
        return args_.find((_arg) => {
          return _arg.name == arg.name;
        });
      });
      args_ = args_.map((arg) => {
        let trgt = filtered.find((_arg) => {
          return _arg.name == arg.name;
        });
        if (trgt) {
          return trgt;
        } else {
          return arg;
        }
      });

      v.meta.arguments = cloneDeep(args_);
    },
  },
  mounted() {},
  watch: {
    "meta.template": function () {
      let v = this;
      v.calculate_variables();
    },
  },
};
</script>
<style></style>
